import { PlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';

interface EmptyEventNotificationsProps {
  onCreate: () => void;
  canWrite: boolean;
}

export const EmptyEventNotifications = ({ onCreate, canWrite }: EmptyEventNotificationsProps) => {
  const { t } = useTranslation();

  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia>
          <img src="/assets/empty-states/event-notifications.webp" alt="" />
        </EmptyMedia>
        <EmptyTitle>{t('developer_tools.event_notifications_empty_title')}</EmptyTitle>
        <EmptyDescription>
          {t('developer_tools.event_notifications_empty_description')}
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button size="sm" onClick={onCreate} disabled={!canWrite}>
          <PlusIcon size={16} />
          {t('common.create')}
        </Button>
      </EmptyContent>
    </Empty>
  );
};
